import { Tooltip } from "@mui/material";
import { getEventCardBGColor } from "../../utils/getEventCardBGColor.js";
import time_icon from "../../../assets/images/time_icon.svg";
import open_popup_icon from "../../../assets/images/open_popup_icon.svg";
import "./EventCard.css";

const EventCard = ({ event, onViewDetails, isDeleteMode, onDeleteClick }) => {
  const { cardColor, buttonColor } = getEventCardBGColor(event.name);
  const eventLevel = event.level;
  const eventRound = event.round;

  // Format the IST time strings to show only time
  const startTime = new Date(event.start_date_time).toLocaleTimeString(
    "en-US",
    {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }
  );

  const endTime = new Date(event.end_date_time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const eventTime = `${startTime} - ${endTime}`;

  return (
    <div className="event-card" style={{ background: cardColor }}>
      <div className="event-top">
        {event.name.length >= 20 ? (
          <Tooltip title={event.name} placement="top" arrow>
            <h3>{event.name}</h3>
          </Tooltip>
        ) : (
          <h3>{event.name}</h3>
        )}
        <h4>
          {eventLevel} - {eventRound}
        </h4>
      </div>
      <div className="event-mid">
        {isDeleteMode ? (
          `Event ID: ${event.id}`
        ) : (
          <div className="time-container">
            <img src={time_icon} alt="time" className="time-icon" />
            <span>
              {eventTime} <span className="ist-text">IST</span>
            </span>
          </div>
        )}
      </div>
      <div className="event-bottom">
        <button
          className={`event-btn ${isDeleteMode ? "delete-mode" : ""}`}
          style={{ background: isDeleteMode ? "#FF4D4F" : buttonColor }}
          onClick={() =>
            isDeleteMode ? onDeleteClick(event) : onViewDetails(event)
          }
        >
          {isDeleteMode ? (
            "Delete Event"
          ) : (
            <>
              View Event Details
              <img src={open_popup_icon} alt="" className="popup-icon" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default EventCard;
